import { compose } from "redux";
import { RootRef } from "@material-ui/core";
import { useDrag, useDrop } from "react-dnd";
import React, { useCallback, useRef } from "react";

import { invokeIfFunction } from "utils/app.util";
import { ITEM_TYPES } from "features/planner/planner.constants";
import SimpleCalendarDay from "app/components/CalendarYear/SimpleCalendarDay";

export const ISO_WEEK_MONDAY = 1;

const CalendarDay = ({ date, onSelectDates, setSelectedRange, ...rest }) => {
  const dragDropRef = useRef(null);

  const [, drag] = useDrag({
    canDrag: () => !!onSelectDates,
    item: {
      startDate: date,
      type: ITEM_TYPES.CALENDAR_DAY,
    },
  });

  const [, drop] = useDrop({
    canDrop: () => !!onSelectDates,
    accept: ITEM_TYPES.CALENDAR_DAY,
    hover(item) {
      if (!dragDropRef.current) {
        return;
      }

      if (item.startDate === date || item.endDate === date) {
        return;
      }

      item.endDate = date;

      setSelectedRange(item.startDate, item.endDate);
    },
    drop: item => {
      invokeIfFunction(onSelectDates, item.startDate, item.endDate, () =>
        setSelectedRange(null, null),
      );
    },
  });

  const onClick = useCallback(
    () =>
      setSelectedRange(date, date, () =>
        invokeIfFunction(onSelectDates, date, date, () =>
          setSelectedRange(null, null),
        ),
      ),
    [date, onSelectDates, setSelectedRange],
  );

  return (
    <RootRef rootRef={drag(drop(dragDropRef))}>
      <SimpleCalendarDay date={date} onClick={onClick} {...rest} />
    </RootRef>
  );
};

export default compose(React.memo)(CalendarDay);
